import clsx from 'clsx';
import type { ReactNode } from 'react';

interface KbdProps {
  className?: string;
  children: ReactNode;
}

export function Kbd({ className, children }: KbdProps) {
  return (
    <kbd
      className={clsx(
        'inline-flex min-w-[1.5rem] items-center justify-center rounded-[var(--radius-sm)]',
        'border border-border-subtle bg-bg-base px-1.5 py-0.5',
        'font-mono text-[10px] font-medium uppercase tracking-wider text-text-secondary',
        'shadow-[inset_0_-1px_0_rgb(0_0_0_/_0.3),0_1px_0_rgb(0_0_0_/_0.4)]',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
